import Page from "../Page";
import { Grid, Button } from "@mui/material";
import { styled } from "@mui/material/styles";

const Title = styled(`div`)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: "3.125rem",
  whiteSpace: "pre-line",
  textAlign: "center",
  [theme.breakpoints.down("md")]: {
    fontSize: "2.25rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "1.125rem",
  },
}));
const Desc = styled(`div`)(({ theme }) => ({
  color: theme.palette.primary.main,
  whiteSpace: "pre-line",
  textAlign: "center",
  fontSize: "1.5rem",
  [theme.breakpoints.down("md")]: {
    fontSize: "1.125rem",
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "0.875rem",
  },
}));
const Image = styled(`img`)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "270px",
    height: " 215px",
  },
}));

export default function Index({
  image,
  alt,
  title,
  descript,
  onSubmit,
  submit,
  icon,
  isLayout = true,
}) {
  const Render = () => (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      sx={{ marginTop: "120px" }}
    >
      <Image src={image} alt={alt} />

      <Grid item xs={12} container alignItems="center" direction="column">
        <Title>{title}</Title>

        <Desc>{descript}</Desc>
        <Button
          variant="contained"
          onClick={() => {
            onSubmit();
            window.location.reload();
          }}
          startIcon={icon}
          sx={{ marginTop: "40px" }}
        >
          {submit}
        </Button>
      </Grid>
    </Grid>
  );
  return isLayout ? <Page>{Render()}</Page> : Render();
}
